import { AiOutlineClose } from "react-icons/ai";
import { FBProfile } from "~/.server/api";
import { Form, Link, useSearchParams } from "@remix-run/react";
import { useEffect, useState } from "react";
import { useDebounce } from "~/lib/utils";
import { InputComponent } from "~/components";
import { MagnifyingGlass, XCircle } from "phosphor-react";

interface MobileSearchBarProps {
  profiles: FBProfile[];
}

export default function SearchBar({ profiles }: MobileSearchBarProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState<string>(
    searchParams.get("q") || ""
  );

  const debouncedSearchValue = useDebounce(searchValue, 500);

  useEffect(() => {
    const query = debouncedSearchValue.trim();

    setSearchParams((prevParams) => {
      const newParams = new URLSearchParams(prevParams);
      if (query.length > 0) {
        newParams.set("q", query);
      } else {
        newParams.delete("q");
      }
      return newParams;
    });
  }, [debouncedSearchValue, setSearchParams]);

  const handleClear = () => {
    setSearchValue("");
    setSearchParams((prevParams) => {
      const newParams = new URLSearchParams(prevParams);
      newParams.delete("q");
      return newParams;
    });
  };

  return (
    <div className="relative z-10 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl">
      <Form>
        <div className="flex items-center gap-2 w-full p-1 rounded-xl bg-transparent">
          {/* Left Icon */}
          <MagnifyingGlass size={24} weight="duotone" className="text-text1 ml-2" />

          {/* Input: Expand to fill the space */}
          <div className="flex-1">
            <InputComponent
              type="text"
              placeholder="Search by Name"
              value={searchValue}
              onChange={(e) => {
                if (e && typeof e !== 'string' && !(e instanceof Date) && 'target' in e) {
                  setSearchValue(e.target.value);
                }
              }}
            />
          </div>

          {/* Right Icon (Clear) */}
          <button
            type="button"
            className="bg-none border-none text-text1 cursor-pointer focus:outline-none"
            onClick={handleClear}
          >
            <XCircle size={30} weight="duotone" />
          </button>
        </div>
      </Form>

      {/* Optional: Autocomplete list if you want to show profiles here */}
      {/* 
      {profiles.length > 0 && (
        <div className="absolute top-full left-0 w-full bg-background max-h-[60vh] overflow-y-auto shadow-lg z-20 border-b border-gray-300 rounded-b-lg">
          ...
        </div>
      )}
      */}
    </div>
  );
}
